import React, { forwardRef } from 'react';
import styled from 'styled-components';
import { Checkbox as CheckboxMUI, CheckboxProps as CheckboxPropsMUI } from '@mui/material';

export type CheckboxProps = {
    children?: JSX.Element | string
} & CheckboxPropsMUI

const CheckboxStyled = styled(CheckboxMUI)`
`;

/**
 * we do nothing with ref as we use inputRef for material ui. can be removed with react 19
 * @param param0
 * @param ref
 * @returns
 */
const Checkbox = (props: CheckboxProps, ref): JSX.Element => <CheckboxStyled
    color="primary"
    {...props}
>
    {props.children}
</CheckboxStyled>;

export default forwardRef(Checkbox);
